import { result, stringify, US_STATE_CODES, US_STATE_NAMES } from '../shared';

export const key = 'us_state_abbreviation';

export const meta = {
  label: 'US State Abbreviation',
  sensitive: false,
  allowed_contact_types: ['string'],
  allowed_form_types: ['Text'],
};

export function validate(value) {
  const raw = stringify(value);
  if (!raw) {
    return result(false, '', 'US state abbreviation is required');
  }

  const normalizedKey = raw.toLowerCase().replace(/[^a-z]/gi, '');

  if (
    normalizedKey.length === 2 &&
    Object.prototype.hasOwnProperty.call(
      US_STATE_CODES,
      normalizedKey.toUpperCase()
    )
  ) {
    return result(true, normalizedKey.toUpperCase());
  }

  if (Object.prototype.hasOwnProperty.call(US_STATE_NAMES, normalizedKey)) {
    return result(true, US_STATE_NAMES[normalizedKey]);
  }

  return result(
    false,
    raw.toUpperCase(),
    'US state abbreviation must be a valid two-letter state code or state name'
  );
}

export function normalize(value) {
  const res = validate(value);
  return res.valid ? res.value : stringify(value).toUpperCase();
}

export function display(value) {
  const res = validate(value);
  return res.valid ? res.value : stringify(value).toUpperCase();
}

export function getInputProps() {
  return {
    maxlength: 20,
  };
}
